import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';

const Unsupported = createReactClass({
  displayName: 'Unsupported',
  mixins: [BaseMixin],

  render: function() {
    return (
      <div className="alert alert-warning">
        Unsupported terminal: { this.terminalName() }
      </div>
    );
  }
});

export default Unsupported;
